import { getDetailedErrorMessage } from "../../../utils/validation";
export class ProductPricingFetchFailed extends Error {
    /**
     * @param apiError - The error received from the API.
     * @param fallbackMessage - The message to use if the API error is not relevant.
     */
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ProductPricingFetchFailed);
        }
        this.name = "ProductPricingFetchFailed";
        this.message = `Failed to fetch product pricing. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
export class ProductPricingSaveFailed extends Error {
    /**
     * @param apiError - The error received from the API.
     * @param fallbackMessage - The message to use if the API error is not relevant.
     */
    constructor(apiError, fallbackMessage = "Failed to save product pricing. Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ProductPricingSaveFailed);
        }
        this.name = "ProductPricingSaveFailed";
        this.message = `Failed to save product pricing. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
//# sourceMappingURL=errors.js.map